<template>
  <div class="home">
    <h1>România, Rumänien</h1>
    <h2>ţara de oameni buni - Ein Land voller freundlicher Menschen</h2>
    <article>
      Doriţi o prelungare? Faceţi un click pe o posa!
Posele marcat cu "nn" nu sânt de la mine.<br/>
				Klicken Sie auf ein Foto, 
				um eine Vergrößerung zu erhalten<br>
				Mit (nn) markierte Fotos stammen nicht von mir.
    </article>
    <article class="fotos">
      <div class="foto">
        <img src="../assets/fotos/revo_1kl.jpg" width="125" height="110" border="0" alt="Opfer der Revolution 1989"
        @click="callImageClick('Bucureşti, Bukarest: Friedhof der Opfer der Revolution von 1989 (nn)', 'revo_1.jpg', $event)">
        <br>Bucureşti, Bukarest: Friedhof der Opfer der Revolution von 1989 (nn)
      </div>
      <div class="foto">
        <img src="../assets/fotos/procesiune_1kl.jpg" width="125" height="110" border="0" alt="ukrainische Prozession in Lugoj"
        @click="callImageClick('Lugoj, Lugosch: ukrainische Kirchweih', 'procesiune_1.jpg', $event)">
        <br>Lugoj: ukrainische Kirchweih
      </div>
      <div class="foto">
        <img src="../assets/fotos/sigh_3kl.jpg" width="125" height="110" border="0" alt="Viehmarkt" 
        @click="callImageClick('Maramuresch: Bäuerin auf dem Viehmarkt in Sighetul Marmaţiei', 'sigh_3.jpg', $event)">
        <br>Maramuresch: Bäuerin auf dem Viehmarkt in Sighetul Marmaţiei
      </div>
      <div class="foto">
        <img src="../assets/fotos/rum_taenzer1_kl.jpg" width="125" height="110" border="0" alt="Tänzer" 
        @click="callImageClick('rumänische Tänzer auf der Expo 2000 in Hannover', 'rum_taenzer1.jpg', $event)">
        <br>rumänische Tänzer auf der Expo 2000 in Hannover
      </div>
      <div class="foto">
        <img src="../assets/fotos/caru_2kl.jpg" width="125" height="110" border="0" alt="Pferdewagen, caruta cu caie bune" 
        @click="callImageClick('Pferdewagen', 'caru_2.jpg', $event)">
        <br>Pferdewagen
      </div>
      <div class="foto">
        <img src="../assets/fotos/sibi_1kl.jpg" width="125" border="0" height="110" alt="Sibiu / Hermannstadt 
        - ev. Kirche" 
        @click="callImageClick('Hermannstadt, Sibiu: deutsch-evangelische Kirche', 'sibi_1.jpg', $event)">
        <br>Hermannstadt, Sibiu: deutsch-evangelische Kirche
      </div>
    </article>
  </div>
</template>

<script>
export default {
  name: 'home',
  methods: {
  callImageClick(imgText, imgName, event) {
     this.$parent.handleImageClick(imgText, imgName, event);
    }
  }
}
</script>

<style>
</style>

